// =============================================================================
// app/src/componentes/Segmentado.tsx — o seletor de "modo" da tela.
//
// O padrão mais repetido do app (20+ lugares) tinha CINCO estilos de ativo e
// oito paddings diferentes — não por decisão, por cópia. Este componente
// canoniza UM (23/08/2026; Grafite em 29/10/2026):
//
//   ativo = fundo #2A2A30 com texto claro (`bg-edge text-paper`), dentro de
//           uma trilha do cartão — o seletor segmentado do desenho aprovado.
//
// Até 28/10 o ativo era a borda vermelha da marca com tinta a 10%. No Grafite
// o vermelho fica só no símbolo e no anel de foco: o ativo é NEUTRO, e quem
// diz "este" é o degrau de cinza (e o `aria-pressed`, para quem não vê). Na
// impressão o fundo some, e a borda do ativo é o que marca qual cenário saiu
// no papel.
//
// Adoção INCREMENTAL de propósito: as telas tocadas pelas ondas A/B usam já;
// o resto migra em PRs de manutenção, uma tela por vez — trocar 20 telas de
// uma vez sem teste visual é como se cria regressão silenciosa.
// =============================================================================

export interface ItemSegmentado<T extends string> {
  id: T;
  rotulo: string;
}

export default function Segmentado<T extends string>({ itens, valor, aoMudar, toque = false }: {
  itens: ReadonlyArray<ItemSegmentado<T>>;
  valor: T;
  aoMudar: (id: T) => void;
  /**
   * 44 px de alvo no celular (Grafite, 29/10/2026), e os 32 de sempre a partir
   * do `sm`. Opt-in, tela a tela: ligar em todas de uma vez engordaria 20
   * telas no celular sem ninguém olhar para elas.
   */
  toque?: boolean;
}) {
  return (
    <div className="inline-flex max-w-full flex-wrap gap-1 rounded-[0.625rem] border border-fio bg-panel p-[3px]">
      {itens.map((i) => (
        <button key={i.id} type="button" onClick={() => aoMudar(i.id)}
                aria-pressed={valor === i.id}
                className={`${toque ? 'min-h-11 sm:min-h-8' : 'min-h-8'} rounded-lg border px-3 py-1 text-xs font-medium transition-[color,background-color] ${
                  valor === i.id
                    ? 'border-edge bg-edge text-paper'
                    : 'border-transparent text-mute hover:text-paper'}`}>
          {i.rotulo}
        </button>
      ))}
    </div>
  );
}
